/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding initialization code.
 * Use "quasar new plugin <name>" and add it there.
 * One plugin per concern. Then reference the file(s) in quasar.conf.js > plugins:
 * plugins: ['file', ...] // do not add ".js" extension to it.
 **/



import 'quasar-extras/roboto-font/roboto-font.css'

import 'quasar-extras/material-icons/material-icons.css'

import 'quasar-extras/mdi/mdi.css'

import 'quasar-extras/fontawesome/fontawesome.css'




import 'quasar-app-styl'


import 'src/css/app.styl'


import Vue from 'vue'
import createApp from './app.js'




import pMain from 'src/plugins/main'

import pRouting from 'src/plugins/routing'

import pI18n from 'src/plugins/i18n'

import pAddressbarcolor from 'src/plugins/addressbar-color'

import pAxios from 'src/plugins/axios'

import pIcorapi from 'src/plugins/icorapi'



import { addPreFetchHooks } from './client-prefetch.js'












const { app, store, router } = createApp()




;[pMain,pRouting,pI18n,pAddressbarcolor,pAxios,pIcorapi].forEach(plugin => {
  plugin({
    app,
    router,
    store,
    Vue,
    ssrContext: null
  })
})





addPreFetchHooks(router, store)





new Vue(app)






